import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { NavigationExtras, Router } from '@angular/router';
import { ActiveUserSessionService } from 'services/activeusersession.service';
import { NavigationService } from 'services/navigation.service';

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss']
})
export class InformationComponent implements OnInit {
  activeuser: any;
  productId: any;
  unitNo: any;
  unitName: any;

  constructor(
    private router: Router,
    public navigationService: NavigationService,
    private activeUserSessionService: ActiveUserSessionService,
    public dialogRef: MatDialogRef<InformationComponent>
  ) {
    this.activeuser = this.activeUserSessionService.getUserDatas();
    this.productId = this.activeUserSessionService.getProductId(); 
    this.unitNo = this.activeUserSessionService.getUnitNo(); 
    this.unitName = this.activeUserSessionService.getUnitName(); 
   }

  ngOnInit() {
  }
  
  onLogin() {
    this.navigationService.goToLogin();
    let navigationExtras: NavigationExtras = {
      queryParams: {
        "latitude": this.activeuser.latitude,
        "longitude":  this.activeuser.longitude,
        "address":  this.activeuser.address,
        "locationReference":  this.activeuser.locationReference,
        "coverageStatus": this.activeuser.coverageStatus,
        "productId":  this.productId, 
        "addressLine1":  this.activeuser.addressLine1,
        "city":  this.activeuser.city,
        "region":  this.activeuser.region, 
        "pincode":  this.activeuser.pincode,
        "unitNo":  this.unitNo, 
        "unitName": this.unitName ,    
   
      }
    };
  
    this.router.navigate(['/login'], navigationExtras);
    this.dialogRef.close();
  }

  onRegister() {

     this.navigationService.goToRegister(false);
    let navigationExtras: NavigationExtras = {
      queryParams: {
        "latitude": this.activeuser.latitude,
        "longitude":  this.activeuser.longitude,
        "address":  this.activeuser.address,
        "locationReference":  this.activeuser.locationReference,
        "coverageStatus": this.activeuser.coverageStatus,
        "productId":  this.productId, 
        "addressLine1":  this.activeuser.addressLine1,
        "city":  this.activeuser.city,
        "region":  this.activeuser.region, 
        "pincode":  this.activeuser.pincode,  
        "unitNo":  this.unitNo, 
        "unitName": this.unitName ,       
      }
    };
  
    this.router.navigate(['/register'], navigationExtras);

    this.dialogRef.close();
  }
 
  onCancel() {
    this.dialogRef.close();
  }



}
